import script from "./SearchComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchComponent.vue?vue&type=script&lang=ts&setup=true"

import "./SearchComponent.vue?vue&type=style&index=0&id=a5d3c0ba&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5d3c0ba"]])

export default __exports__